<template>
  <b-modal
    centered
    v-model="editorShown"
    title="Send Fax"
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
    header-class="bg-purple"
  >
    <template v-slot:modal-footer>
      <b-button
        class="bg-med-light-gray"
        variant="light"
        @click="editorShown = false"
      >
        Cancel
      </b-button>
      <b-button variant="primary" @click.prevent="sendFax">
        Send
      </b-button>
    </template>
    <b-form-group
      label="Sender name"
      :invalid-feedback="formErrors.fromName.join(', ')"
      :state="formErrors.fromName.length == 0 ? null : false"
    >
      <template v-slot:label>
        Sender name <span class="text-danger">*</span>
      </template>
      <b-form-input type="text" v-model="form.fromName" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label="Sender number"
      :invalid-feedback="formErrors.fromFaxNumber.join(', ')"
      :state="formErrors.fromFaxNumber.length == 0 ? null : false"
    >
      <template v-slot:label>
        Sender number <span class="text-danger">*</span>
      </template>
      <phone-input
        v-model="form.fromFaxNumber"
        trim
        :state="formErrors.fromFaxNumber.length == 0 ? null : false"
      ></phone-input>
    </b-form-group>
    <b-form-group
      label="Recipient name"
      :invalid-feedback="formErrors.toName.join(', ')"
      :state="formErrors.toName.length == 0 ? null : false"
    >
      <template v-slot:label>
        Recipient name <span class="text-danger">*</span>
      </template>
      <b-form-input type="text" v-model="form.toName" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label="Recipient number"
      :invalid-feedback="formErrors.toFaxNumber.join(', ')"
      :state="formErrors.toFaxNumber.length == 0 ? null : false"
    >
      <template v-slot:label>
        Recipient number <span class="text-danger">*</span>
      </template>
      <phone-input v-model="form.toFaxNumber" trim></phone-input>
    </b-form-group>
    <loading-overlay />
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import documentServer from "../../server/document";
import scheduleEventServer from "../../server/scheduleEvent";
import {
  validateRequired,
  validatePhoneNumber
} from "../../helpers/validation";
import LoadingOverlay from "../workspace/LoadingOverlay.vue";
import PhoneInput from "../controls/PhoneInput.vue";

export default {
  name: "SendFaxModal",
  components: {
    LoadingOverlay,
    PhoneInput
  },
  props: ["ids", "sendFaxMethod"],
  data() {
    return {
      form: {
        fromName: "",
        fromFaxNumber: "",
        toName: "",
        toFaxNumber: ""
      },
      formErrors: {
        fromName: [],
        fromFaxNumber: [],
        toName: [],
        toFaxNumber: []
      }
    };
  },
  mounted() {
    this.form.fromName = this.selectedLocationObj.name;
    this.form.fromFaxNumber = this.selectedLocationObj.fax;
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "show", "hide"]),
    async sendFax() {
      if (!this.validateForm()) {
        return;
      }
      this.show();
      var data = {
        locationId: this.selectedLocationObj.id,
        fromName: this.form.fromName,
        fromFaxNumber: this.form.fromFaxNumber,
        toName: this.form.toName,
        toFaxNumber: this.form.toFaxNumber,
        ids: this.ids
      };

      if (this.sendFaxMethod == "sendDocumentsPdf") {
        await documentServer.sendDocumentsPdf(data);
      }

      if (this.sendFaxMethod == "sendTreatmentPlanPdf") {
        await documentServer.sendTreatmentPlanPdf(data);
      }

      if (this.sendFaxMethod == "sendGroupSessionPdf") {
        await scheduleEventServer.sendGroupSessionPdf(data);
      }

      if (this.sendFaxMethod == "sendEocPdf") {
        await documentServer.sendEocPdf(data);
      }
      this.hide();
      this.$dialog.alert(
        {
          title:
            "Fax queued, soon you will receive a notification with a status update."
        },
        {
          view: "info"
        }
      );
      this.editorShown = false;
    },
    validateForm() {
      this.formErrors.fromName = [];
      this.formErrors.fromFaxNumber = [];
      this.formErrors.toName = [];
      this.formErrors.toFaxNumber = [];

      let withoutErrors = true;

      if (!validateRequired(this.form.fromName)) {
        this.formErrors.fromName.push("This field is required");
        withoutErrors = false;
      }

      if (!validatePhoneNumber(this.form.fromFaxNumber)) {
        this.formErrors.fromFaxNumber.push("Enter a valid phone number");
        withoutErrors = false;
      }

      if (!validateRequired(this.form.toName)) {
        this.formErrors.toName.push("This field is required");
        withoutErrors = false;
      }

      if (!validatePhoneNumber(this.form.toFaxNumber)) {
        this.formErrors.toFaxNumber.push("Enter a valid phone number");
        withoutErrors = false;
      }

      return withoutErrors;
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocationObj: state => state.selectedLocationObj
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style></style>
